import React from "react";
import Tippy from "@tippyjs/react";
import classnames from "classnames";
import { useTranslation } from "react-i18next";

import { InfoPlate } from "fe-shared/src/components";
import { ClockIcon, RetryIcon } from "fe-shared/src/components/Icons";

import { TRANSACTION_STATUSES_CONFIG_MAP } from "../../helpers/statusesConfig";
import { TransactionStatus } from "../../types";

import styles from "./TransactionStatusPlate.module.scss";

interface Props {
  statusCode: TransactionStatus;
  isAdjustable?: boolean;
  isValidating?: boolean;
  className?: string;
}

export const TransactionStatusPlate = (props: Props) => {
  const { t } = useTranslation();
  const { statusCode, isAdjustable, isValidating, className } = props;
  const variant = statusCode && TRANSACTION_STATUSES_CONFIG_MAP[statusCode];

  if (isValidating) {
    return <RetryIcon />;
  }

  return statusCode && variant ? (
    <div className={classnames(styles.status, className)}>
      <InfoPlate variant={variant}>
        {t(`transactions.statuses.${statusCode}`)}
      </InfoPlate>
      {isAdjustable && (
        <Tippy content={t("transactions.correctionPeriod")}>
          <div className={styles.icon}>
            <ClockIcon width={16} height={16} />
          </div>
        </Tippy>
      )}
    </div>
  ) : (
    <div />
  );
};

export default TransactionStatusPlate;
